import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

type ToastKind = "ok" | "error";
interface Toast { id: number; kind: ToastKind; message: string; }
interface ToastApi { show: (message: string, kind?: ToastKind) => void; }

const ToastCtx = createContext<ToastApi>({ show: () => {} });
export const useToast = () => useContext(ToastCtx);

let _seq = 1;

/** 전역 토스트. 성공/실패 메시지를 우하단에 잠깐 띄운다(Drawer 닫혀도 남음). */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const show = useCallback((message: string, kind: ToastKind = "ok") => {
    const id = _seq++;
    setToasts((t) => [...t, { id, kind, message }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3000);
  }, []);

  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      <div className="toast-stack">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast--${t.kind}`}>{t.message}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
